import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

const AD_SRC = 'https://cms.flirtbees.com/code?ref=1488&promoinfo=flirtbeeschat&locale='

// The CMS ad script injects an iframe into its container. On pages that
// hydrate, loading it after hydration keeps that iframe out of the server
// HTML, so React 18 does not treat it as a mismatch and wipe it. Pages served
// without client JS (unstable_runtimeJS: false) keep the inline script tag.
const AdSlot = () => {
  const router = useRouter()
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current || ref.current.querySelector('script')) {
      return
    }
    const script = document.createElement('script')
    script.src = AD_SRC + router.locale
    ref.current.appendChild(script)
  }, [])

  return (
    <div id='flirtbees-ads' ref={ref}
      style={{ width: '100%', height: '100vh', display: 'inline-block', maxWidth: '100%', textAlign: 'center', padding: '50px 0px' }}>
    </div>
  )
}

export default AdSlot
